// extracted by mini-css-extract-plugin
export default {"root":"tDRK8o","checkbox":"jX6fqK","checkboxError":"dWtN8A"};